import React from "react";
import { Box, Typography, Button, Avatar } from "@mui/material";
import { styled } from "@mui/material/styles";
import { motion } from "framer-motion";
import LogoutIcon from "@mui/icons-material/Logout";
import StarIcon from "@mui/icons-material/Star";
import logo from "../../../Assets/logo.png";

const StyledHeroSection = styled(Box)(({ theme }) => ({
  background: "linear-gradient(135deg, #1800ad 0%, #f57226 100%)",
  borderRadius: "24px",
  color: "white",
  position: "relative",
  overflow: "hidden",
  "&::before": {
    content: '""',
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background:
      'url(\'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="grain" width="100" height="100" patternUnits="userSpaceOnUse"><circle cx="50" cy="50" r="1" fill="%23ffffff" opacity="0.1"/></pattern></defs><rect width="100" height="100" fill="url(%23grain)"/></svg>\') repeat',
    opacity: 0.3,
  },
}));

const HeroSection = ({ logout, onRequestDemo }) => {
  return (
    <StyledHeroSection
      sx={{
        p: 6,
        mb: 6,
        textAlign: "center",
        position: "relative",
        zIndex: 1,
      }}
    >
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <Avatar
          src={logo}
          alt="logo"
          sx={{
            width: 80,
            height: 80,
            mx: "auto",
            mb: 3,
            bgcolor: "#ffffff",
            border: "2px solid rgba(255,255,255,0.12)",
          }}
        >
          {!logo && <StarIcon sx={{ fontSize: 40, color: "white" }} />}
        </Avatar>
        <Typography
          variant="h3"
          gutterBottom
          sx={{
            fontWeight: 800,
            textShadow: "0 2px 10px rgba(0,0,0,0.1)",
            mb: 2,
            color: "#ffffff",
          }}
        >
          مرحباً بك في نظام ريستو كاش لإدارة المطاعم
        </Typography>
        <Typography
          variant="h5"
          sx={{
            opacity: 0.9,
            fontWeight: 400,
            mb: 4,
            maxWidth: 600,
            mx: "auto",
          }}
        >
          أنت غير مشترك حالياً. اختر الباقة المناسبة لك للاستفادة من خدماتنا
          المتميزة
        </Typography>
        <Button
          variant="outlined"
          size="large"
          onClick={logout}
          startIcon={<LogoutIcon />}
          sx={{
            borderColor: "rgba(255,255,255,0.5)",
            color: "white",
            borderRadius: "50px",
            px: 4,
            py: 1.5,
            fontSize: "1.1rem",
            mr: 2,
            "&:hover": {
              borderColor: "#ffffff",
              backgroundColor: "rgba(255,255,255,0.08)",
            },
          }}
        >
          تسجيل الخروج
        </Button>

        <Button
          variant="contained"
          onClick={onRequestDemo}
          sx={{
            background: "linear-gradient(135deg, #1800ad 0%, #f57226 100%)",
            color: "white",
            fontWeight: "bold",
            borderRadius: "50px",
            px: 4,
            py: 1.5,
            fontSize: "1.1rem",
            textTransform: "none",
            letterSpacing: "0.5px",
            boxShadow: "0 6px 20px rgba(24,0,173,0.18)",
            transition: "all 0.3s ease",
            "&:hover": {
              boxShadow: "0 8px 25px rgba(245,114,38,0.25)",
              transform: "translateY(-3px)",
            },
            "&:active": {
              transform: "scale(0.97)",
              boxShadow: "0 4px 12px rgba(24,0,173,0.2)",
            },
          }}
        >
          🚀 اطلب نسخة تجريبية
        </Button>
      </motion.div>
    </StyledHeroSection>
  );
};

export default HeroSection;
